
		<section class="section section--contact">
			<div class="shell">
				<header class="section__head">
					<h1>Contact Us</h1>	
				</header><!-- /.section__head -->

				<div class="section__content">
					<h3>Let Us Help You On Your Trust Journey</h3>

					<p>
						The TrustID<sup>&trade;</sup> Calculator can unlock new understanding of your customers, employees, and partners -- their views of your organization, impacts to behavior, and how all this affects performance in the market. How? By measuring and benchmarking your organization against peers by industry, sector, and category, as well as demographic. HX TrustID<sup>&trade;</sup> limits potential for survey bias by predicting actions based on actual behaviors, not just what customers say they will do. The power of HX TrustID<sup>&trade;</sup> is at your fingertips. Reach out to learn more, and we can help you measure, predict, and act in ways that proactively build trust to earn lifelong loyalty.
					</p>

					<a href="mailto:usexperiencemanagement@deloitte.com" class="btn btn--primary">Email Us</a>
				</div><!-- /.section__content -->
			</div><!-- /.shell -->
		</section><!-- /.section -->

		<section class="section section--gray section--primary">
			<div class="shell">
				
				<ul class="list-actions">
					<li >
						<a (click)="toggleTab('discover')" class="btn">Discover Trust Scores</a>
					</li>
					
					<li>
						<a (click)="toggleTab('behavior')" class="btn btn--green-dark" >Impact Of Trust On Behavior</a>
					</li>

					<li >
						<a (click)="toggleTab('market')" class="btn btn--green" >Impact Of Trust On Market Value</a>
					</li>
				</ul><!-- /.list-actions -->
			</div><!-- /.shell -->
		</section><!-- /.section -->